import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Role } from '../../constants/Role';
import { Link } from 'react-router-dom';
import StatisticsDashboard from '../../components/charts/StatisticsDashboard';
import StaffStatisticsDashboard from '../../components/charts/StaffStatisticsDashboard';
import '../../styles/AdminDashboard.css';

const AdminDashboard = () => {
  const { hasAnyRole, hasAllRoles } = useAuth();
  const isAdminDev = hasAnyRole([Role.ADMIN_DEV]);
  const isAdminBusiness = hasAnyRole([Role.ADMIN_BUSINESS]);
  const isStaffAccounting = hasAnyRole([Role.STAFF_ACCOUNTING]);
  const isStaffCourseManager = hasAnyRole([Role.STAFF_COURSE_MANAGER]);
  
  const canManageCategories = hasAnyRole([Role.ADMIN_DEV, Role.ADMIN_BUSINESS]);
  const canManageCourses = hasAnyRole([Role.ADMIN_DEV, Role.ADMIN_BUSINESS, Role.STAFF_COURSE_MANAGER]);
  const canManageOrders = hasAnyRole([Role.ADMIN_DEV, Role.STAFF_ACCOUNTING]);

  // Determine which dashboard to show based on role
  const getDashboardComponent = () => {
    if (isAdminDev || isAdminBusiness) {
      return <StatisticsDashboard />;
    } else if (isStaffAccounting || isStaffCourseManager) {
      return <StaffStatisticsDashboard />;
    }
    return null;
  };

  return (
    <div className="admin-dashboard-container">

      {/* Welcome Message based on role */}
      <div className="admin-welcome-section">
        {isAdminDev && (
          <div className="welcome-message admin-dev">
            <h2>Welcome, System Administrator!</h2>
            <p>You have full access to all system features and configurations.</p>
          </div>
        )}
        {isAdminBusiness && (
          <div className="welcome-message admin-business">
            <h2>Welcome, Business Administrator!</h2>
            <p>You can manage business operations, assign categories to staff and course management.</p>
          </div>
        )}
        {isStaffAccounting && (
          <div className="welcome-message staff-accounting">
            <h2>Welcome, Accounting Staff!</h2>
            <p>You can manage orders, payments, and financial reports.</p>
          </div>
        )}
        {isStaffCourseManager && (
          <div className="welcome-message staff-course-manager">
            <h2>Welcome, Course Manager!</h2>
            <p>You can manage courses, create lessons, and organize content.</p>
          </div>
        )}
      </div>

      {/* Quick Actions */}
      <div className="admin-quick-actions">
        <h2 className='statistics-dashboard' style={{color:"#163e73", fontWeight:"bold"}}>Quick Actions</h2>
        <div className="quick-actions-grid">
          {canManageCategories && (
            <Link to="/manage/categories" className="quick-action-card">
              <div className="quick-action-icon">📂</div>
              <h4>Manage Categories</h4>
              <p>Create, edit, and organize course categories</p>
            </Link>
          )}
          
          {canManageCourses && (
            <Link to="/manage/courses" className="quick-action-card">
              <div className="quick-action-icon">📚</div>
              <h4>Manage Courses</h4>
              <p>View and manage course content</p>
            </Link>
          )}
          
          {canManageOrders && (
            <Link to="/manage/orders" className="quick-action-card">
              <div className="quick-action-icon">📋</div>
              <h4>Order Management</h4>
              <p>View and manage customer orders</p>
            </Link>
          )}
          
          <div className="quick-action-card">
            <div className="quick-action-icon">📊</div>
            <h4>Analytics</h4>
            <p>View system statistics and reports</p>
          </div>
        </div>
      </div>

      {/* Statistics Dashboard - Role-based */}
      <div className="admin-statistics-section">
        {getDashboardComponent()}
      </div>

      {/* Role-based Information */}
      <div className="admin-role-info">
        <h3>Your Permissions</h3>
        <div className="permissions-list">
          {isAdminDev && (
            <div className="permission-item">
              <span className="permission-icon">🔧</span>
              <span>Full system access and configuration</span>
            </div>
          )}
          {isAdminBusiness && (
            <div className="permission-item">
              <span className="permission-icon">💼</span>
              <span>Business operations management</span>
            </div>
          )}
          {isStaffAccounting && (
            <div className="permission-item">
              <span className="permission-icon">💰</span>
              <span>Financial and order management</span>
            </div>
          )}
          {isStaffCourseManager && (
            <div className="permission-item">
              <span className="permission-icon">📝</span>
              <span>Course content creation and management</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 